export default () => ({
  entity: 'favoriteList',
  entities: 'favoriteListes',
  favoriteListes: [],
  errors: {
  },
  prefixRouter: 'patient.favorite-list.index'
})



// WEBPACK FOOTER //
// ./src/app/patient/favorite-list/resources/data.js